var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-md-time",
    "data-name": "Icon ionic-md-time",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.558,
    height: 20.558,
    viewBox: "0 0 20.558 20.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M13.644,3.375A10.279,10.279,0,1,0,23.933,13.654,10.275,10.275,0,0,0,13.644,3.375Zm.01,18.5a8.223,8.223,0,1,1,8.223-8.223A8.223,8.223,0,0,1,13.654,21.877Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M18.079,10.688H16.538v6.167l5.4,3.237.771-1.265-4.625-2.743Z",
    transform: "translate(-7.287 -5.548)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.a4fdd6d56eabfda7920334cf9db73032.svg";
export { ForwardRef as ReactComponent };